import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Provider } from 'jotai';
import { analyticsConfig } from 'syf-js-utilities/helpers/triggerAnalyticsEvent';
import v2TriggerAnalyticsEvent from './helpers/triggerAnalyticsEvent';
import { MAPFlowTypes } from './typings/deepLink';
import PaymentModal from './ui/organisms/PaymentModal';
import makeAPaymentStore from './store';
export { MAPFlowTypes } from './typings/deepLink';
const MakeAPayment = ({ analyticsConfig: analyticsConfigProp, accountId, accountLast4, apiErrorCallback, containerId, featureFlags, handleClose, handleCloseOnConversion, helpNumber, hosts, id, isOpen, lang, triggerAnalyticsEvent: triggerAnalyticsEventProp, additionalProps = {
    flow: { type: MAPFlowTypes.ONE_TIME_PAYMENT_FLOW }
} }) => {
    const triggerAnalyticsEventFn = analyticsConfigProp
        ? v2TriggerAnalyticsEvent
        : triggerAnalyticsEventProp;
    /*
     * This effect sets our instance of syf-js-utilities with the channel-level syf-js-utilities config defaults (e.g. PageKind, ClientName, etc).
     * We will only do this when we're passed an analytics object without an analytics trigger function.
     * This is a patch so we don't have to force all channel MFEs to bump their utils version to our version.
     */
    useEffect(() => {
        if (isOpen && analyticsConfigProp) {
            Object.keys(analyticsConfig.defaults).forEach((defaultKey) => {
                analyticsConfig.defaults[defaultKey] =
                    analyticsConfigProp.defaults[defaultKey];
            });
        }
    }, [isOpen, analyticsConfigProp]);
    return (_jsx(Provider, Object.assign({ store: makeAPaymentStore }, { children: _jsx(PaymentModal, { accountId: accountId, accountLast4: accountLast4, additionalProps: additionalProps, apiErrorCallback: apiErrorCallback, containerId: containerId, featureFlags: featureFlags, handleClose: handleClose, handleCloseOnConversion: handleCloseOnConversion, helpNumber: helpNumber, hosts: hosts, id: id, isOpen: isOpen, lang: lang, triggerAnalyticsEvent: triggerAnalyticsEventFn }) })));
};
export default MakeAPayment;
